// ============================================================================
// CANCUN100 — BandaVersion.js  (Bloque 30: "Hay una versión nueva de la app · Actualizar / Más tarde")
// ----------------------------------------------------------------------------
// Banda discreta tipo "cookies": fija abajo; ancho completo en móvil, 420 px abajo a la derecha en escritorio.
// RADIO_TARJETA, SOMBRA y fuente de src/tema.js. No bloquea nada: se sigue trabajando con la banda visible.
// El padre decide cuándo mostrarla (useVersion + sin modal abierto ni envío en curso).
// ============================================================================
import React from 'react';
import { RADIO, RADIO_TARJETA, SOMBRA, ALTO_BOTON } from './tema';

export default function BandaVersion({ C, visible, onActualizar, onMasTarde, versionNueva }) {
  if (!visible) return null;
  const movil = typeof window !== 'undefined' && window.innerWidth < 640;
  return (
    <div role="status" aria-live="polite" style={{
      position: 'fixed', zIndex: 650, bottom: movil ? 0 : 16, right: movil ? 0 : 16, left: movil ? 0 : 'auto', width: movil ? '100%' : 420, boxSizing: 'border-box',
      background: C.card || C.surface, color: C.text, border: `1px solid ${C.border}`, borderRadius: movil ? `${RADIO_TARJETA}px ${RADIO_TARJETA}px 0 0` : RADIO_TARJETA,
      boxShadow: SOMBRA, padding: '14px 16px', fontFamily: 'var(--au-font-text)', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
    }}>
      <div style={{ flex: '1 1 180px', minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 700 }}>Hay una versión nueva de la app.</div>
        <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>Al actualizar no se pierde lo que estés capturando{versionNueva ? ` · ${versionNueva}` : ''}.</div>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <button type="button" onClick={onMasTarde} style={{ height: ALTO_BOTON, boxSizing: 'border-box', padding: '0 12px', background: 'transparent', border: 'none', color: C.muted, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--au-font-text)', borderRadius: RADIO }}>Más tarde</button>
        <button type="button" onClick={onActualizar} style={{ height: ALTO_BOTON, boxSizing: 'border-box', padding: '0 16px', background: 'var(--equipo-grad)', border: 'none', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'var(--au-font-text)', borderRadius: RADIO }}>Actualizar</button>
      </div>
    </div>
  );
}
